/**
 * セルの色分け（log_web_issues#338 C2）のエリア既定色。
 *
 * 既定色は FE が持つ。API（`company_dispatch_cell_colors`）は会社が変えた色だけを覚え、
 * 触っていない区分はキーごと持たない。会社ごとに 10 + 47 行を初期投入しなくても
 * 最初から色が付いた状態で使えるようにするため。
 *
 * 値はサンプル（route-planner `src/constants/regionMaster.ts` の `defaultColor`）の 10 色を
 * そのまま引き継ぐ。区分の切り方が同じ（10 区分・所属県も同一）で、名前だけ
 * 「近畿」→「関西」が違うため、色を選び直す理由が無い。
 *
 * キーと並びは API の `Region::REGIONS`（planning_api app/models/region.rb）と同じにする。
 * ここがずれると、API が返す `loading_area` / `unloading_area` の文字列と突き合わせられない。
 *
 * Why not 都道府県ぶんの既定色も持つ: 県の色は「その県が属するエリアの色」で足りる
 * （サンプル `CellColorSettingsDialog.tsx:122` と同じ・ユーザー判断 2026-09-28）。
 * どの県がどのエリアかは API が `areas` で返すので、FE に変換表の写しを置かずに済む。
 */
export const DEFAULT_AREA_COLORS: Record<string, string> = {
  北海道: '#0ea5e9',
  東北: '#14b8a6',
  関東: '#3b82f6',
  甲信越: '#8b5cf6',
  北陸: '#6366f1',
  東海: '#f59e0b',
  関西: '#ef4444',
  中国: '#84cc16',
  四国: '#06b6d4',
  '九州・沖縄': '#ec4899',
};
